import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Icon from 'Components/Icon';
import Drawer from 'Components/Drawer';
import NoSSR from 'Components/NoSSR';
import { useSelector } from 'react-redux';

const defaultPositionProps = { web: 'right', mobile: 'bottom' };

const Modal = props => {
  const {
    onOpen,
    onClose,
    //showClose,
    children,
    title,
    iconName,
    isOpen,
    type,
    container,
    buttonArea,
    position,
    closeIconVisible,
    closeIconName,
    disableOverlayClick,
    lockBackgroundScroll,
    className,
    headerColor,
    centered = false,
    modalSize = 'normal',
    buttonsReversed = false,
    showCloseOnBottom = false,

  } = props;
  const userAgent = useSelector(state => state.userAgent);
  const drawerPosition = { ...defaultPositionProps, ...position };

  // disableOverlayClick
  // closebutton hidden

  // icon neden geç geliyor.

  useEffect(() => {
    if (isOpen && onOpen) {
      onOpen();
    }
  }, [isOpen]);

  
  return (
    <NoSSR>
      <Drawer
        className={ className }
        headerColor = { headerColor }
        icon={ iconName ? <Icon className={ `modal__container__icon${ type ? ` modal__container__icon--${ type }` : '' }` } iconName={ iconName } /> : undefined }
        type={ type }
        open={ isOpen }
        lockBackgroundScroll={ lockBackgroundScroll }
        buttonArea={ buttonArea }
        position={ userAgent.device?.type === 'desktop' ? drawerPosition.web : drawerPosition.mobile  }
        // buttonArea={ drawerData.buttonArea || drawerContent.buttonArea }
        // isCancelButtonVisible={ drawerData.isCancelButtonVisible }
        container={ container }
        closeIconVisible={ closeIconVisible }
        closeIconName={ closeIconName }
        disableOverlayClick={ disableOverlayClick }
        title={ title }
        centered={ centered }
        modalSize={ modalSize }
        buttonsReversed={ buttonsReversed }
        showCloseOnBottom={ showCloseOnBottom }
        onClose={ () => {
          onClose();
        } }>
        { children }
      </Drawer>
    </NoSSR>
  );

};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.string,
  iconName: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error', 'waiting', 'warning']),
  buttonArea: PropTypes.any,
  container: PropTypes.node,
  position: PropTypes.shape({
    mobile: PropTypes.oneOf(['left', 'right', 'bottom', 'top', 'center']),
    web: PropTypes.oneOf(['left', 'right', 'bottom', 'top', 'center'])
  }),
  closeIconVisible: PropTypes.bool,
  closeIconName: PropTypes.string,
  disableOverlayClick: PropTypes.bool,
  className: PropTypes.string,
  lockBackgroundScroll: PropTypes.bool,
  headerColor: PropTypes.string,
  centered: PropTypes.bool,
  modalSize: PropTypes.oneOf(['normal', 'large']),
  buttonsReversed: PropTypes.bool,
  showCloseOnBottom: PropTypes.bool
};

Modal.defaultProps = {
  onOpen: null,
  showClose: true,
  overlayClick: true,
  isOpen: true,
  buttonArea: null,
  position: defaultPositionProps,
  closeIconVisible: true,
  disableOverlayClick: false,
  lockBackgroundScroll: true,
};


export default Modal;
